import script from "./RoomAvailabilityComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomAvailabilityComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomAvailabilityComponent.vue?vue&type=style&index=0&id=4f2ae15c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2ae15c"]])

export default __exports__